// import useAuthContext from './useAuthContext';

const useContextToken = () => {
  // const { user, contextToken: authContextToken } = useAuthContext();

  // if (user?.context_token) {
  //   return { contextToken: `&context_token=${user.context_token}` };
  // } else if (authContextToken) {
  //   return { contextToken: `&context_token=${authContextToken}` };
  // }

  return { contextToken: '' };
};

export default useContextToken;
